'use strict';

import jQuery from 'jquery';
import googletag from './../../vendor/google-tag';
import Utilities from './../Utilities/Utilities';
import {getAdTargetsForCurrentPage} from './helpers';

var GoogleTagAdLoader = (function($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      // Namespace for Google Ad slots
      adSlots: {},
      // A list of breakpoints that the Google ads should be
      adRefreshBreakpoints: {},
      // The default options
      defaults: {
        // The account id to load ads for
        accountId: null,
      },
      adSettings: {},
      initializedPromise: undefined 
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function () {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a private reference to the utilities for internal usage
      privateNS.utils = Utilities;

      // Initialize ad refresh handling to false
      privateNS.adResizehHandlerBound = false;

      privateNS.initializedPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          try {
            // Initialize the Google ad service
            privateNS.initalizeAdSlots();
            // Load the ads for the various ad spaces on the page
            privateNS.displayAds();
          } catch (exception) {
            reject();
          }

          resolve();
        }, 5000);
      });

      // Store the current page width as a breakpoint marker
      privateNS.currentBreakpoint = window.outerWidth;

      try {
        privateNS.adSettings = JSON.parse(window.localStorage.getItem('ad-settings')) || {};
      } catch (e) {}

      // Return the reference to the publicly accessible functions
      return publicNS;
    };

    privateNS.shouldDisplayAd = function shouldDisplayAd(adUnit) {
      if (typeof privateNS.adSettings[adUnit] !== 'undefined') {
        if (privateNS.adSettings[adUnit].display === false &&
          privateNS.adSettings[adUnit].expires > Math.floor(Date.now() / 1000)) {
          return false;
        }
      }

      return true;
    };

    /**
     * Creates the ad slots across the entire site
     */
    privateNS.initalizeAdSlots = function initializeAdSlots() {

      // Make sure that an account id has been set before trying to create ads
      if (privateNS.options.accountId !== null) {

        // Add the ad load command to the googletag queue to run when the
        // library has finished loading
        googletag.cmd.push(function() {

          // Load in all of the Google ad spaces on the page
          var $adTags = $('.googletag-ad');

          // For each ad space on the page initialize it with its settings
          $adTags.each(function (index, element) {

            // jQuery each passes in the raw DOM element. Wrap it with jQuery
            // for simpler access to data attributes
            var $ad = $(element);

            if (privateNS.shouldDisplayAd($ad.attr('data-unit'))) {

              // Extract the ad information from the DOM
              var adUnit = $ad.attr('data-unit'),
                width = $ad.attr('data-width') | 0,
                height = $ad.attr('data-height') | 0,
                collapse = $ad.attr('data-collapse'),
                sizeMappings = $ad.attr('data-size-mappings'),
                targetKey = $ad.attr('data-target-key'),
                targetValue = $ad.attr('data-target-value'),
                cookieFlag = $ad.attr('data-cookie-flag');

              if ($.cookie(cookieFlag) !== true) {

                // Generate a uuid for this ad slot
                var adUuid = privateNS.utils.weakUuid();

                // Create a new instance of this ad slot for the page
                var newAdSlot = googletag.defineSlot(
                  '/' + privateNS.options.accountId + '/' + adUnit,
                  [width, height],
                  adUuid
                );

                newAdSlot.set('uuid', adUuid);

                // Set the id of the DOM element to the uuid
                $ad.attr('id', adUuid);

                // Set the uuid for the ad back on to the DOM
                $ad.attr('data-uuid', adUuid);

                // If a size mapping was defined, generate a mapping for the ad
                if (sizeMappings) {

                  // Try to parse the size mappings in to an array
                  try {

                    // Parse the mapping data in to and array
                    var mappingData = JSON.parse(sizeMappings);

                    // Make sure at least one mapping exists before doing work
                    if (mappingData.length > 0) {

                      // Extract from the mappings breakpoints that should be defined
                      // for resize events
                      for (var i = 0; i < mappingData.length; i++) {

                        // Extract the browser dimension parameter from the mapping.
                        // Then extract just the width dimension.
                        var browserDimensions = mappingData[i][0],
                          browserWidth = browserDimensions[0];

                        // Ignore 0 width breakpoints, these are default ad
                        // size mapping configurations
                        if (browserWidth !== 0) {

                          // Add the breakpoint for this ad slot to the cached breakpoints
                          privateNS.addResizeBreakpoint(newAdSlot, browserWidth);
                        }
                      }

                      // Update this ad slot with the generated size mapping
                      newAdSlot.defineSizeMapping(mappingData);
                    }
                  } catch (exception) {
                    // Silently fail if an ad is not configured properly
                  }
                }

                // If the collapse ad attribute was defined then update the ad slot
                // with the collapse preference
                if (collapse) {

                  // Try to parse the collapse preference
                  try {

                    // Parse the collapse value to a boolean
                    var collapsePreference = JSON.parse(collapse);

                    // Only set the preference if the preference if it properly
                    // parsed to a boolean value
                    if (typeof collapsePreference === 'boolean') {
                      newAdSlot.setCollapseEmptyDiv(collapsePreference);
                    }

                  } catch (exception) {
                    // Silently fail if an ad is not configured properly
                  }
                }

                // If both a targeting key and targeting value have been set, parse
                // them and update the ad unit with them
                if (targetKey && targetValue) {

                  // Try to parse the target key and target value
                  var adTargetKey = JSON.parse(targetKey),
                    adTargetValue = JSON.parse(targetValue);

                  // Update the ad slot with the specified preferences
                  newAdSlot.setTargetting(adTargetKey, adTargetValue);
                }

                // Now that the ad slot has been built and configure, register it
                // to serve ads
                newAdSlot.addService(googletag.pubads());

                // Finally add the new ad to the tracking list of ads
                privateNS.adSlots[newAdSlot.get('uuid')] = newAdSlot;
              }
            }
          });

          // After all of the ad slots on the page have been generated, start up
          // the ad serving services
          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
        });
      }
    };

    /**
     * Parses the document and displays all ad blocks on the page based
     * on the rules that have been configured with googletag
     */
    privateNS.displayAds = function displayAds() {

      // Find all of the Google ad tags on the page
      var $adTags = $('.googletag-ad');

      // Loop through all of the ad tags and initialize them with the ad service
      $adTags.each(function queueAdRegistration(index, adTag) {

        // Note: jQuery each passes in the list index and the raw DOM element,
        // not a jQuery wrapped element. adTag does not have jQuery access by
        // default
        googletag.cmd.push(function () {
          googletag.display(adTag.id);
        });
      });
    };

    /**
     * Returns access to a promise that is setup in init that resolves
     * when ads are initialized  
     */
   publicNS.whenInitialized = function whenInitialized() {
      return privateNS.initializedPromise;
   }

    /**
     * Goes through the configured ad slots and builds a list of ad slots that
     * need to be refreshed based on a change in the breakpoints. This list is
     * passed off to the googletag service for ad refresh
     */
   privateNS.refreshAdUnits = function refreshAdUnits() {
      // Get the new width of the page to determine if a breakpoint has
      // been passed. Then retrieve and store the min and max of the two
      // page widths
      var newBreakpoint = window.outerWidth,
        minBreakpoint = Math.min(privateNS.currentBreakpoint, newBreakpoint),
        maxBreakpoint = Math.max(privateNS.currentBreakpoint, newBreakpoint);

      // Create a list of ad slots to refresh
      var adSlotsToRefresh = [];

      // Go through the known breakpoints and save of any ad slots that have
      // a breakpoint in between the new and old page widths
      for (var uuid in privateNS.adRefreshBreakpoints) {

        // Property check to make sure this is an proper property
        if (privateNS.adRefreshBreakpoints.hasOwnProperty(uuid)) {

          // Get the ad slot sizes that are mapped to this ad slot
          var adSlotBreakpoints = privateNS.adRefreshBreakpoints[uuid];

          // Loop through each of define ad slot size breakpoints and check it
          // against the current breakpoint
          for (var i = 0; i < adSlotBreakpoints.length; i++) {

            // Check to see if the ad slot breakpoint is in between the old
            // and the new window breakpoints.
            if (minBreakpoint < adSlotBreakpoints[i] && adSlotBreakpoints[i] <= maxBreakpoint) {

              // Add the reference to the generated ad slot to the refresh list
              adSlotsToRefresh.push(privateNS.adSlots[uuid]);

              // Once an ad slot is adding to the refresh list, stop processing
              // any of its other breakpoints
              break;
            }
          }
        }
      }

      // If at least one ad was found that needs to be refresh, do a refresh of
      // specifically those ads
      if (adSlotsToRefresh.length > 0) {
        googletag.pubads().refresh(adSlotsToRefresh);
      }

      // Store the new window breakpoint for future resize events
      privateNS.currentBreakpoint = newBreakpoint;
    };

    /**
     * Adds a refresh breakpoint for a given ad slot. Also adds the resize
     * handler to the document that refreshes the responsive ads if needed.
     * This handler is not attached until the an ad with a breakpoint is set up
     *
     * @param adSlot string The ad slot to add a breakpoint for
     * @param breakpoint int The browser width breakpoint to add
     */
    privateNS.addResizeBreakpoint = function addResizeBreakpoint(adSlot, breakpoint) {

      // Pull out the ads uuid
      var uuid = adSlot.get('uuid');

      // Check to see if this ad slot has any breakpoints currently set. If it
      // does then add the passed breakpoint to the list. Otherwise create
      // a new list with the breakpoint
      if (privateNS.adRefreshBreakpoints[uuid] && privateNS.adRefreshBreakpoints[uuid].length > 0) {
        privateNS.adRefreshBreakpoints[uuid].push(breakpoint);
      } else {
        privateNS.adRefreshBreakpoints[uuid] = [breakpoint];
      }

      // Check to see if the resize handler has been created yet, if it has not
      // then create it
      if (privateNS.adResizehHandlerBound === false) {

        // Bind to the window resize event with a gracious debounce so that
        // ads don't get refreshed multiple times
        $(window).on(
          'resize',
          privateNS.utils.debounce(
           privateNS.refreshAdUnits,
            1000
          )
        );

        // Mark that the resize event has been bound, so it is not done again
        privateNS.adResizehHandlerBound = true;
      }
    };

    /**
     * Give an id for an element on the page, initializes an ad in the place of that element.
     * Returns the random uuid assigned that is generate for that ad
     *
     * @param id
     * @returns {string}
     */
    publicNS.initializeAd = function initNewAds(id) {

      // Generate a uuid for this ad slot
      let adUuid = privateNS.utils.weakUuid();

      googletag.cmd.push(function() {
        let element = document.getElementById(id);

        // jQuery each passes in the raw DOM element. Wrap it with jQuery
        // for simpler access to data attributes
        var $ad = $(element);

        // Extract the ad information from the DOM
        var adUnit = $ad.attr('data-unit'),
          width = $ad.attr('data-width') | 0,
          height = $ad.attr('data-height') | 0,
          collapse = $ad.attr('data-collapse'),
          sizeMappings = $ad.attr('data-size-mappings'),
          targetKey = $ad.attr('data-target-key'),
          targetValue = $ad.attr('data-target-value');

        // Create a new instance of this ad slot for the page
        var newAdSlot = googletag.defineSlot(
          '/' + privateNS.options.accountId + '/' + adUnit,
          [width, height],
          adUuid
        );

        // Ad a uuid attribute to the ad slot for book keeping
        newAdSlot.set('uuid', adUuid);

        // Set the id of the DOM element to the uuid
        $ad.attr('id', adUuid);

        // Set the uuid for the ad back on to the DOM
        $ad.attr('data-uuid', adUuid);

        // If a size mapping was defined, generate a mapping for the ad
        if (sizeMappings) {

          // Try to parse the size mappings in to an array
          try {

            // Parse the mapping data in to and array
            var mappingData = JSON.parse(sizeMappings);

            // Make sure at least one mapping exists before doing work
            if (mappingData.length > 0) {

              // Extract from the mappings breakpoints that should be defined
              // for resize events
              for (var i = 0; i < mappingData.length; i++) {

                // Extract the browser dimension parameter from the mapping.
                // Then extract just the width dimension.
                var browserDimensions = mappingData[i][0],
                  browserWidth = browserDimensions[0];

                // Ignore 0 width breakpoints, these are default ad
                // size mapping configurations
                if (browserWidth !== 0) {

                  // Add the breakpoint for this ad slot to the cached breakpoints
                  privateNS.addResizeBreakpoint(newAdSlot, browserWidth);
                }
              }

              // Update this ad slot with the generated size mapping
              newAdSlot.defineSizeMapping(mappingData);
            }
          } catch (exception) {
            // Silently fail if an ad is not configured properly
          }
        }

        // If the collapse ad attribute was defined then update the ad slot
        // with the collapse preference
        if (collapse) {

          // Try to parse the collapse preference
          try {

            // Parse the collapse value to a boolean
            var collapsePreference = JSON.parse(collapse);

            // Only set the preference if the preference if it properly
            // parsed to a boolean value
            if (typeof collapsePreference === 'boolean') {
              newAdSlot.setCollapseEmptyDiv(collapsePreference);
            }

          } catch (exception) {
            // Silently fail if an ad is not configured properly
          }
        }

        // If both a targeting key and targeting value have been set, parse
        // them and update the ad unit with them
        if (targetKey && targetValue) {

          // Try to parse the target key and target value
          var adTargetKey = JSON.parse(targetKey),
            adTargetValue = JSON.parse(targetValue);

          // Update the ad slot with the specified preferences
          newAdSlot.setTargetting(adTargetKey, adTargetValue);
        }

        // Now that the ad slot has been built and configure, register it
        // to serve ads
        newAdSlot.addService(googletag.pubads());

        // Finally add the new ad to the tracking list of ads
        privateNS.adSlots[newAdSlot.get('uuid')] = newAdSlot;

        // Setup targets on ad slot based on the current page
        let adTargets = getAdTargetsForCurrentPage();
        const adTargetKeys = Object.keys(adTargets);
        adTargetKeys.forEach(key => newAdSlot.setTargeting(key, adTargets[key]));
      });

      return adUuid;
    };

    /**
     * Given a random uuid that was generate for an ad container, attempts to display that ad
     *
     * @param uuid
     */
    publicNS.displayAd = function displayAd(uuid) {
      googletag.cmd.push(function () {
        googletag.display(uuid);
      });

    };

    /**
     * Schedules callback to be called when googletag becomes available, or if it is
     * already available
     *
     * @param cb
     */
    publicNS.onload = function onload(cb) {
      googletag.cmd.push(function() {
        cb();
      });
    };

    /**
     * Updates the stored account id with the ad loader
     *
     * @param accountId int|string The account number to store
     */
    publicNS.setAccountId = function setAccountId(accountId) {

      // Update the stored account id with the passed in account id
      privateNS.options.accountId = accountId;
    };

    /**
     * Retrieves and returns the account id store with the ad loader
     *
     * @returns int|string The store account id
     */
    publicNS.getAccountId = function getAccountId() {

      // Return the stored account id
      return privateNS.options.accountId;
    };

    /**
     * Public getter method for accessing a single ad slot
     *
     * @param adUuid string The uuid of an ad slot to look up
     *
     * @return array|null Returns an array of googletag slots if one exists any
     *                    exist for the passed in adSlot, otherwise returns null
     */
    publicNS.getAdSlot = function getAdSlot(adUuid) {
      return privateNS.adSlots[adUuid] || null;
    };

    /**
     * Public getter method for accessing the ad slots
     *
     * @return object Returns an array of parsed ad slots
     */
    publicNS.getAdSlots = function getAdSlots() {
      return privateNS.adSlots;
    };

    // Return a new instance
    return privateNS.init();
  };
})(jQuery);

export default GoogleTagAdLoader